var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AssetUploadV2',{key:_vm.slot._fullpath,ref:"asset",attrs:{"asset":_vm.slot,"parent":_vm.parent,"creative":_vm.creative,"parent_slot":_vm.parent_slot},on:{"change":function($event){return _vm.change('asset')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }